import { IPlugin } from './models';

export class PluginRegistry {

    protected plugins: { [key: string]: new<T>() => IPlugin<T> } = {};

    add<T>(alias: string, constructorFunction: new<T>() => IPlugin<T>) {
        if (alias in this.plugins) {
            console.warn('More than 1 plugin was registered with the same key, only the last one will be available. Make sure your plugins are registered with unique keys');
        }
        this.plugins[alias] = constructorFunction;
    }

    get<T>(alias: string): IPlugin<T> {
        if (alias in this.plugins) {
            return new this.plugins[alias]();
        }
        console.warn(`Plugin '${alias}' not found. Make sure you invoked InstanceManager.registerPlugin('${alias}',plugin_constructor) before trying to use it.`);
    }
}
